export const heroOne = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Our Clients Get Results!',
	},
	headline: "Organic Traffic, Online Leads, and Top Keyword Results",
	description: 'Ready to Grow Your Business With Premium Marketing Services?',
	buttonLabel: 'GET FREE PROPOSAL',
	imgStart: 'start',
	img: './assets/png/Deal.png',
	start: 'true',
};

export const heroTwo = {
	reverse: false,
	inverse: false,
	topLine: {
		text: 'Growing Businesses Since 2005',
	},
	headline: 'A wide range of online solutions.',
	description: 'Multiply Your ROI With The Best Digital Marketing Solutions',
	buttonLabel: 'Get Started',

	linkTo: '/more',
	imgStart: 'start',
	img: './assets/png/Connection.png',
	start: 'true',
};

export const heroThree = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'The results speak for themselves',
	},
	headline: 'We Deliver Promptly',
	description:
		' our customers truly come first. We understand that every business is unique. We take the time to learn your specific goals.',
	buttonLabel: 'Contact Us',

	linkTo: '/download',
	imgStart: '',
	img: './assets/png/ChartUp.png',
	start: 'true',
};
